var _style, _defs, _defs2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198.6 172.9",
    style: {
      enableBackground: "new 0 0 198.6 172.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000114762384767739851210000009266909262354719158_);fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000114762384767739851210000009266909262354719158_);}\n\t.st2{clip-path:url(#SVGID_00000114762384767739851210000009266909262354719158_);fill:#C42031;}\n\t.st3{clip-path:url(#SVGID_00000024709035778812621380000009423455137762809486_);fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_00000024709035778812621380000009423455137762809486_);}\n\t.st5{clip-path:url(#SVGID_00000024709035778812621380000009423455137762809486_);fill:#C42031;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 625.4,
    height: 172.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107580742458595498220000003277362713722777007_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000107580742458595498220000003277362713722777007_)",
      fill: "#FFFFFF"
    },
    d: "M198.6,147.2 c0.1,11.9-11.6,25.7-25.8,25.7H29c-14.2,0-29-10.5-29-32.6V25.4C0,11.2,13,0,27.2,0h146.1c14.2,0,25.4,12,25.4,26.2V147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000107580742458595498220000003277362713722777007_)"
    },
    d: "M192.4,70.7V25.9 c0-11-9.7-19.8-21.6-19.8H28C16,6.1,6.2,15,6.2,25.9v63.4l46.9-73.7h30.5l5.2,30c6.9-1,13.9-1.6,21-1.6 C140.7,44.1,169.2,54,192.4,70.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000107580742458595498220000003277362713722777007_)"
    },
    d: "M65.2,31.9H65l-15.9,26 c6.2-2.9,12.6-5.5,19.2-7.5L65.2,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000107580742458595498220000003277362713722777007_)",
      fill: "#C42031"
    },
    d: "M192.3,73.1 c-19.5-11.7-42.1-18.5-66.5-18.5c-12.2,0-23.7,1.4-34.9,4.6l12.9,76.8l26.7-62.9h33.2l-2.1,61.5L192.3,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000107580742458595498220000003277362713722777007_)",
      fill: "#C42031"
    },
    d: "M173.7,157.2h-31.3 l1.9-67.4H144l-27.4,67.4H86.3L71.1,66.8C45.5,78.1,9.5,105.3,6.4,137c-0.2,1.2-0.1,4.1-0.1,4.2c0.1,14.3,11.6,25.5,26,25.5h139 c11.8-0.2,21.2-11.5,21.2-22.3v-27L173.7,157.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062149890329709993800000007224600884706692523_",
    x: -8.7,
    y: -272.9,
    width: 625.4,
    height: 172.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125601801991960739840000006237892416463210153_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062149890329709993800000007224600884706692523_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)",
      fill: "#FFFFFF"
    },
    d: "M189.9-125.7 c0.1,11.9-11.6,25.7-25.8,25.7H20.3c-14.2,0-29-10.5-29-32.6v-114.9c0-14.2,13-25.4,27.2-25.4h146.1c14.2,0,25.4,12,25.4,26.2 V-125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    d: "M183.7-202.1V-247 c0-11-9.7-19.8-21.6-19.8H19.3c-12,0-21.7,8.9-21.7,19.8v63.4l46.9-73.7h30.5l5.2,30c6.9-1,13.9-1.6,21-1.6 C132-228.8,160.5-218.9,183.7-202.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    d: "M56.5-241h-0.3l-15.9,26 c6.2-2.9,12.6-5.5,19.2-7.5L56.5-241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)",
      fill: "#C42031"
    },
    d: "M183.6-199.8 c-19.5-11.7-42.1-18.5-66.5-18.5c-12.2,0-23.7,1.4-34.9,4.6l12.9,76.8l26.7-62.9H155l-2.1,61.5L183.6-199.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)",
      fill: "#C42031"
    },
    d: "M165-115.7h-31.3 l1.9-67.4h-0.3l-27.4,67.4H77.6l-15.2-90.4c-25.6,11.3-61.6,38.5-64.7,70.3c-0.2,1.2-0.1,4.1-0.1,4.2c0.1,14.3,11.6,25.5,26,25.5 h139c11.8-0.2,21.2-11.5,21.2-22.3v-27L165-115.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)",
      fill: "#C42031"
    },
    points: "209.2,-203.7  225.1,-203.7 236.5,-166 236.6,-166 250.2,-203.7 265.3,-203.7 278.9,-166 279,-166 290.4,-203.7 306.3,-203.7 289,-152.3  270.2,-152.3 257.8,-186.3 257.7,-186.3 245.2,-152.3 226.5,-152.3  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)",
      fill: "#C42031"
    },
    d: "M330.9-175.3 c0,7.5,1.6,10.3,9.3,10.3h20.9c7.7,0,9.4-2.8,9.4-10.3v-5.5c0-6.4-1.6-10.3-10.2-10.3h-19.1c-8.6,0-10.2,3.9-10.2,10.3V-175.3z  M314.1-185.7c0-15.1,8.8-18.6,23.5-18.6h26.2c14.7,0,23.5,3.5,23.5,18.6v15.3c0,15-8.8,18.6-23.5,18.6h-26.2 c-14.7,0-23.5-3.6-23.5-18.6V-185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)",
      fill: "#C42031"
    },
    d: "M417.9-178.5h27 c4.4,0,6-1.7,6-5.4v-1.7c0-4.5-2.4-5.4-7.5-5.4h-25.5V-178.5z M401.6-203.7h49.3c12.6,0,16,6,16,15.3v3.3c0,6.9-1.6,10.9-9.1,12.6 v0.1c4.8,0.8,8.9,2.9,8.9,11.4v8.7h-16.4v-6.2c0-5.4-1.6-7.2-6.7-7.2h-25.7v13.4h-16.3V-203.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)",
      fill: "#C42031"
    },
    points: "481.6,-203.7  497.9,-203.7 497.9,-165.5 534.7,-165.5 534.7,-152.3 481.6,-152.3  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)",
      fill: "#C42031"
    },
    d: "M561.6-165.5h29 c7,0,9.7-1.9,9.7-9.2v-7c0-7.3-2.7-9.2-9.7-9.2h-29V-165.5z M545.3-203.7h49.3c16.3,0,22.1,5.2,22.1,17.9v15.6 c0,12.7-5.8,17.9-22.1,17.9h-49.3V-203.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    d: "M238.6-235.2h21.1L249-254.8 L238.6-235.2z M238.3-266.8h21.5l29.6,51.9h-18.4l-5.1-9.2h-33.5l-4.8,9.2h-18.5L238.3-266.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    points: "299.7,-266.8 316.2,-266.8  316.2,-228.2 356.5,-228.2 356.5,-214.9 299.7,-214.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    points: "368.8,-266.8 385.3,-266.8  385.3,-228.2 425.6,-228.2 425.6,-214.9 368.8,-214.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: -266.8,
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    width: 16.5,
    height: 51.9
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    points: "472.6,-266.8 534.2,-266.8  534.2,-254.8 489.1,-254.8 489.1,-246.4 529.3,-246.4 529.3,-235.7 489.1,-235.7 489.1,-227.3 535.1,-227.3 535.1,-214.9  472.6,-214.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    d: "M561.7-228.6h29c7,0,9.7-1.9,9.7-9.2 v-7c0-7.3-2.7-9.2-9.7-9.2h-29V-228.6z M545.4-266.8h49.3c16.4,0,22.1,5.2,22.1,17.9v15.6c0,12.7-5.7,17.9-22.1,17.9h-49.3V-266.8z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: -141,
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    width: 12.7,
    height: 34.9
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    points: "270.7,-106.1 253.1,-122.8  250.4,-125.4 250.3,-125.4 250.4,-121.6 250.4,-106.1 239,-106.1 239,-141 249.1,-141 264.9,-125.5 267.5,-122.8 267.6,-122.9  267.5,-126.6 267.5,-141 278.9,-141 278.9,-106.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    d: "M305.3-105.4c-5.7,0-11-1.1-15.4-3 l1.4-9.5c4.7,2.2,9.6,3.4,14.5,3.4c4.1,0,5.8-0.8,5.8-2c0-3.1-21.5,0.2-21.5-13.1c0-6.2,4.8-12,17.7-12c4.5,0,10.2,0.7,14.2,2 l-1.4,9.1c-4.6-1.2-9-1.8-12.6-1.8c-5.2,0-6,0.9-6,1.9c0,3.4,21.5-0.5,21.5,13C323.4-110.1,316.1-105.4,305.3-105.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    d: "M372.5-121 c0,10.4-6.5,15.7-19.7,15.7c-13.1,0-19.9-5.3-19.9-15.7V-141h12.5v20c0,4,2.2,6,7.4,6c5.3,0,7.3-2,7.3-6v-20h12.4V-121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    d: "M402.8-132.3h-6v7.9h5.9 c3.8,0,5.4-1,5.4-4.2C408.1-131.3,406.7-132.3,402.8-132.3 M413.8-119.1l10.9,13h-15l-6.9-10.6h-5.9v10.6h-12.6V-141h19 c11.5,0,17.9,4.2,17.9,11.8C421.2-124.8,418.5-120.5,413.8-119.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    d: "M452-128.8l-3.5,8.4h9.6l-3.3-8.4 l-1.3-3.5h-0.1L452-128.8z M461.5-111.8H445l-2.3,5.7h-13.4l17.2-34.9h13.9l17.6,34.9h-14.2L461.5-111.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    points: "518.1,-106.1 500.5,-122.8  497.9,-125.4 497.7,-125.4 497.8,-121.6 497.8,-106.1 486.4,-106.1 486.4,-141 496.5,-141 512.3,-125.5 515,-122.8 515.1,-122.9  515,-126.6 515,-141 526.3,-141 526.3,-106.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    d: "M570.1-130.9 c-2.7-0.7-5.8-1.3-9.7-1.3c-8.2,0-10,2.4-10,8.5c0,6.5,2,8.7,10,8.7c3.6,0,6.9-0.6,9.7-1.7l1.5,8.5c-3.8,1.6-8.3,2.6-12.7,2.6 c-14.1,0-21.8-6.9-21.8-18.2c0-10.4,7.1-18.1,23.1-18.1c4,0,8.1,0.7,11.2,1.6L570.1-130.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000125601801991960739840000006237892416463210153_)"
    },
    points: "616.1,-115.4 615.9,-106.1  581.7,-106.1 581.7,-141 615.1,-141 615.3,-131.6 594.2,-131.6 594.2,-127.7 611.7,-127.7 611.7,-119.7 594.2,-119.7 594.2,-115.4  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f4d064236b85d5075b860d4d0512643.svg";
export { ForwardRef as ReactComponent };